import React, { useContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { NotificationsState } from './store';

interface NotificationsContextValue
  extends Pick<
    NotificationsState,
    'notifications' | 'isNotifyLoading' | 'supportRefreshSignal'
  > {
  setNotifications: Dispatch<
    SetStateAction<NotificationsState['notifications']>
  >;
}

export const NotificationsContext = React.createContext<
  NotificationsContextValue | undefined
>(undefined);
export const NotificationsStoreContext = React.createContext(null);
export const NotificationsSetterContext = React.createContext(null);

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(
      'useNotifications must be used within a NotificationsProvider'
    );
  }
  return context;
};

export const useSetNotifications = () => useContext(NotificationsSetterContext);
